/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoodsDetail } from './GoodsDetail';
import {
    GoodsDetailFromJSON,
    GoodsDetailFromJSONTyped,
    GoodsDetailToJSON,
    GoodsDetailToJSONTyped,
} from './GoodsDetail';
import type { BillCreateAdditionalServiceItem } from './BillCreateAdditionalServiceItem';
import {
    BillCreateAdditionalServiceItemFromJSON,
    BillCreateAdditionalServiceItemFromJSONTyped,
    BillCreateAdditionalServiceItemToJSON,
    BillCreateAdditionalServiceItemToJSONTyped,
} from './BillCreateAdditionalServiceItem';

/**
 * 
 * @export
 * @interface BatchBillOrderReqVo
 */
export interface BatchBillOrderReqVo {
    /**
     * 订单编码
     * @type {string}
     * @memberof BatchBillOrderReqVo
     */
    orderCode: string;
    /**
     * 预检时的订单状态（由precheck接口返回，保存时回传用于一致性校验）
     * @type {number}
     * @memberof BatchBillOrderReqVo
     */
    orderStatus?: number;
    /**
     * 预检时的订单修改时间（由precheck接口返回，保存时回传用于乐观锁校验）
     * @type {string}
     * @memberof BatchBillOrderReqVo
     */
    orderUpdateTime?: string;
    /**
     * 预检时的商品数量（由precheck接口返回，保存时回传用于商品一致性校验）
     * @type {number}
     * @memberof BatchBillOrderReqVo
     */
    goodsCount?: number;
    /**
     * 用户ID
     * @type {number}
     * @memberof BatchBillOrderReqVo
     */
    userId: number;
    /**
     * 计算货物运费的单位：1-kg，2-lbs，3-cbm，4-cm
     * @type {number}
     * @memberof BatchBillOrderReqVo
     */
    applyUnit?: number;
    /**
     * 适用货物运费的值（所有箱子之和，根据applyUnit确定单位）
     * @type {number}
     * @memberof BatchBillOrderReqVo
     */
    applyValue?: number;
    /**
     * 货物收费总金额，默认为0
     * @type {number}
     * @memberof BatchBillOrderReqVo
     */
    totalGoodsAmount?: number;
    /**
     * 附加服务总金额，默认为0
     * @type {number}
     * @memberof BatchBillOrderReqVo
     */
    totalAdditionalServiceAmount?: number;
    /**
     * 账单总金额 = totalGoodsAmount + totalAdditionalServiceAmount + totalTransferAmount
     * @type {number}
     * @memberof BatchBillOrderReqVo
     */
    totalAmount: number;
    /**
     * 货物明细列表
     * @type {Array<GoodsDetail>}
     * @memberof BatchBillOrderReqVo
     */
    goodsDetailList?: Array<GoodsDetail>;
    /**
     * 附加服务明细列表
     * @type {Array<BillCreateAdditionalServiceItem>}
     * @memberof BatchBillOrderReqVo
     */
    additionalServiceList?: Array<BillCreateAdditionalServiceItem>;
    /**
     * 退货运单号（仅billType=5或11时传入）
     * @type {string}
     * @memberof BatchBillOrderReqVo
     */
    returnCode?: string;
}

/**
 * Check if a given object implements the BatchBillOrderReqVo interface.
 */
export function instanceOfBatchBillOrderReqVo(value: object): value is BatchBillOrderReqVo {
    if (!('orderCode' in value) || value['orderCode'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    return true;
}

export function BatchBillOrderReqVoFromJSON(json: any): BatchBillOrderReqVo {
    return BatchBillOrderReqVoFromJSONTyped(json, false);
}

export function BatchBillOrderReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchBillOrderReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderCode': json['orderCode'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'orderUpdateTime': json['orderUpdateTime'] == null ? undefined : json['orderUpdateTime'],
        'goodsCount': json['goodsCount'] == null ? undefined : json['goodsCount'],
        'userId': json['userId'],
        'applyUnit': json['applyUnit'] == null ? undefined : json['applyUnit'],
        'applyValue': json['applyValue'] == null ? undefined : json['applyValue'],
        'totalGoodsAmount': json['totalGoodsAmount'] == null ? undefined : json['totalGoodsAmount'],
        'totalAdditionalServiceAmount': json['totalAdditionalServiceAmount'] == null ? undefined : json['totalAdditionalServiceAmount'],
        'totalAmount': json['totalAmount'],
        'goodsDetailList': json['goodsDetailList'] == null ? undefined : ((json['goodsDetailList'] as Array<any>).map(GoodsDetailFromJSON)),
        'additionalServiceList': json['additionalServiceList'] == null ? undefined : ((json['additionalServiceList'] as Array<any>).map(BillCreateAdditionalServiceItemFromJSON)),
        'returnCode': json['returnCode'] == null ? undefined : json['returnCode'],
    };
}

export function BatchBillOrderReqVoToJSON(json: any): BatchBillOrderReqVo {
    return BatchBillOrderReqVoToJSONTyped(json, false);
}

export function BatchBillOrderReqVoToJSONTyped(value?: BatchBillOrderReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderCode': value['orderCode'],
        'orderStatus': value['orderStatus'],
        'orderUpdateTime': value['orderUpdateTime'],
        'goodsCount': value['goodsCount'],
        'userId': value['userId'],
        'applyUnit': value['applyUnit'],
        'applyValue': value['applyValue'],
        'totalGoodsAmount': value['totalGoodsAmount'],
        'totalAdditionalServiceAmount': value['totalAdditionalServiceAmount'],
        'totalAmount': value['totalAmount'],
        'goodsDetailList': value['goodsDetailList'] == null ? undefined : ((value['goodsDetailList'] as Array<any>).map(GoodsDetailToJSON)),
        'additionalServiceList': value['additionalServiceList'] == null ? undefined : ((value['additionalServiceList'] as Array<any>).map(BillCreateAdditionalServiceItemToJSON)),
        'returnCode': value['returnCode'],
    };
}

